import React, { useEffect, useState } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Divider,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    Snackbar,
} from '@mui/material';
import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';

const PwdTextField = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}

            {...props}
        />        
    )
}

const MyInfo = () => {
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [init, setInit] = useState(true);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    
    const [openPwdDlg, setOpenPwdDlg] = useState(false);
    const [oldPwd, setOldPwd] = useState('');
    const [newPwd, setNewPwd] = useState('');

    const [openChargeDlg, setOpenChargeDlg] = useState(false);
    const [chargeMoney, setChargeMoney] = useState('200000');
    const [chargerName, setChargerName] = useState('');



    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });

    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const paramUserEmail = searchParams.get('userEmail') || undefined;
    const paramUserPw = searchParams.get('userPw') || undefined;
    const queryList = [...searchParams];

    useEffect(() => {
        actions.extendTime(userData);
/*
        if (userData) {
            setName(userData.userName || '');
            setEmail(userData.userEmail || '');
            setPhone(userData.userPhone || '');
            
        }
*/
 
    }, [init]);

    useEffect(() => {
        actions.extendTime(userData);
        /*
                if (userData) {
                    setName(userData.userName || '');
                    setEmail(userData.userEmail || '');
                    setPhone(userData.userPhone || '');
                    
                }
        */
        if (userData && userData.userName) {
            setChargerName(userData.userName);
        }
    }, [userData]);



    const login = async () => {

        try {

            const reqData = {};
            reqData.userEmail = paramUserEmail;
            reqData.userPW = paramUserPw;


            let response = await axios.post("/api/booking/CheckUser", reqData);
            //            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.unlimitUser = userInfo.unlimitUser;

                updateUserInfo(newData);
                //("myinfo save new userdata")
                //                checkLogin();


            }
        } catch (err) {
            console.error(err);
        }

    }

    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar:true })
    }

    const getChargeMoney = () => {
        if (!userData || !userData.chargeMoney) {
            return null;
        }
        let curMoney = userData.chargeMoney;

        if (!curMoney) {
            curMoney = 0;
        }
        let formattedNumber = curMoney.toLocaleString('ko-KR', {
            style: 'currency',
            currency: 'KRW',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        return formattedNumber;
    }


    const getPhoneNumber = () => {
        if (!userData || !userData.userPhone) {
            return null;
        }
        const result = userData.userPhone.replace(/[^0-9.]/g, "")
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
            .replace(/(-{1,2})$/g, "");
        
        return result;
    }


    const handleSave = () => {
        // Logic to save profile data
        //('Profile saved:', { name, email, phone });
    };


    const handlePwdDlg = () => {
        //("old :" + oldPwd + ", new :" + newPwd)
        changePwd();
        setOpenPwdDlg(false);
        setOldPwd('');
        setNewPwd('');
    }



    const changePwd = async () => {

        try {

            const reqData = {};
            reqData.userEmail = userData.userEmail;
            reqData.userPW = oldPwd;
            reqData.userNewPW = newPwd


            let response = await axios.post("/api/booking/ChangePwd", reqData);
            //("ChangePwd result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                showSnackBar('비밀번호 변경 성공');

            } else {
                showSnackBar('비밀번호 변경 실패');

            }
        } catch (err) {
            console.error(err);
            showSnackBar('비밀번호 변경 실패');
        }

    }

    const closePwdDlg = () => {
        setOldPwd('');
        setNewPwd('');
        setOpenPwdDlg(false);
    }

    const renderPasswordDlg = () => {
        return (
            <Dialog open={openPwdDlg} onClose={() => closePwdDlg()}>
                <DialogTitle>비밀번호 변경</DialogTitle>
                <DialogContent sx={{ paddingBottom: 0 }}>
                    <DialogContentText>
                        변경하고자 하는 비밀번호를 입력하세요
                    </DialogContentText>
                    <PwdTextField
                        autoFocus
                        required
                        margin="dense"
                        id="olgPwd"
                        name="oldPwd"
                        label="기존 비밀번호"
                        fullWidth
                        variant="standard"
                        value={oldPwd}
                        autoComplete="current-password"
                        onChange={(e) => setOldPwd(e.target.value)}
                        
                    />
                    <PwdTextField
                        required
                        margin="dense"
                        id="newPwd"
                        name="newPwd"
                        label="새로운 비밀번호"
                        fullWidth
                        variant="standard"
                        value={newPwd}
                        autoComplete="current-password"
                        onChange={(e) => setNewPwd(e.target.value)}
                    />
                    <DialogActions>
                        <Button onClick={() => closePwdDlg()}>취소</Button>
                        <Button
                            disabled={oldPwd.length > 0 && newPwd.length > 0 ? false : true}
                            onClick={() => handlePwdDlg()}>
                            변경
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        )
    }


    const handleChargeDlg = () => {
        sendChargeResult();
        setOpenChargeDlg(false);
    }



    const closeChargeDlg = () => {
        setOpenChargeDlg(false);
    }


    const sendChargeResult = async () => {
        const reqData = {};

        if (Number(chargeMoney) < 200000) {
            showSnackBar('최저 충전액은 200,000원 입니다');
            return false;
        }


        reqData.userEmail = userData.userEmail;
        reqData.userChargerName = chargerName;
        reqData.userChargeMoney = Number(chargeMoney);


        try {
            const response = await axios.post(Config.app_server + "/api/booking/SendChargeAlert", reqData);

            if ((response.data.code === 0)) {
                showSnackBar('입금정보 전송 성공');
            } else {
                showSnackBar('입금정보 전송 실패');
            }
        } catch (err) {
            console.error(err);
            showSnackBar('입금정보 전송 실패');

        }

    }




    const renderChargeAlert = () => {

        //("renderChargeAlert chargerName :" + chargerName)
        //("renderChargeAlert chargeMoney :" + chargeMoney)

        if (!chargerName || !chargeMoney) {
            return null;
        }

        return (
            <Dialog open={openChargeDlg} onClose={() => closeChargeDlg()}>
                <DialogTitle>입금정보 전송</DialogTitle>
                <DialogContent sx={{ paddingBottom: 0 }}>
                    <DialogContentText>
                        입금한 내용을 입력하세요
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        label="입금자명"
                        fullWidth
                        variant="standard"
                        value={chargerName}
                        onChange={(e) => setChargerName(e.target.value)}

                    />
                    <TextField
                        required
                        margin="dense"
                        label="입금액"
                        fullWidth
                        variant="standard"
                        value={chargeMoney}
                        onChange={(e) => setChargeMoney(e.target.value)}
                    />
                    <DialogActions>
                        <Button onClick={() => closeChargeDlg()}>취소</Button>
                        <Button
                            disabled={chargerName.length > 0 && chargeMoney.length > 0 ? false : true}
                            onClick={() => handleChargeDlg()}>
                            전송
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        )
    }


    const renderMoneyPart = () => {
        return (
            <>

                <Stack
                    direction="row" spacing={2}
                    sx={{
                        alignItems: "center",
                        padding: { xs: 2, sm: 2, md: 2 },
                        backgroundColor: 'background.paper',
                        borderRadius: { xs: 1, sm: 2 },
                        //                        mx: 'auto', // Center the card horizontally
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                    >
                        입금계좌
                    </Typography>
                    <Stack>
                        <Typography variant="subtitle1">카카오뱅크</Typography>
                        <Typography variant="subtitle1">3333-26-9516128 김x준</Typography>
                        <Typography color="warning" variant="body2">최소충전금액: 20만원</Typography>
                    </Stack>
                </Stack>

                <Stack
                    direction="row" spacing={2}
                    sx={{
                        alignItems: "center",
                        padding: { xs: 2, sm: 2, md: 2 },
                        backgroundColor: 'background.paper',
                        borderRadius: { xs: 1, sm: 2 },
                        //                        mx: 'auto', // Center the card horizontally
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                    >
                        입금정보
                    </Typography>

                    <Button variant="contained" sx={{ mt: 2 }} onClick={() => setOpenChargeDlg(true)} >
                        입금내역 전송
                    </Button>

                </Stack>
            </>
        )
    }

    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid  xs={12} sm={6} md={4}>
                        <Typography variant="h4" gutterBottom>
                            {userData && userData.userName ? userData.userName : ''}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            {userData && userData.userEmail ? userData.userEmail : ''}
                        </Typography>
                        <Typography variant="h6" color="text.secondary"  sx={{ mt: 1 }}>
                            {getPhoneNumber()}
                        </Typography>
                        <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setOpenPwdDlg(true)}>
                            비밀번호 변경
                        </Button>
                    </Grid>

                </Grid>

                <Divider sx={{ my: 3 }} />

                

                <Stack
                    direction="row" spacing={2}
                    sx={{
                        alignItems: "center",
                        padding: { xs: 2, sm: 2, md: 2 },
                        backgroundColor: 'background.paper',
                        borderRadius: { xs: 1, sm: 2 },
//                        mx: 'auto', // Center the card horizontally
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                    >
                        충전금액
                    </Typography>
                    <Typography variant="h6">
                        {getChargeMoney()}
                    </Typography>
                </Stack>
                <Stack
                    direction="row" spacing={2}
                    sx={{
                        alignItems: "center",
                        padding: { xs: 2, sm: 2, md: 2 },
                        backgroundColor: 'background.paper',
                        borderRadius: { xs: 1, sm: 2 },
                        //                        mx: 'auto', // Center the card horizontally
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                    >
                        부킹횟수
                    </Typography>
                    <Stack>
                        <Typography variant="subtitle1">토탈 : {userData.chargeCount + userData.bonusCount}회</Typography>
                        <Typography variant="body2">유료 {userData.chargeCount}회, 보너스 {userData.bonusCount}회</Typography>
                    </Stack>
                </Stack>

                {renderMoneyPart()}    
               
            </Paper>
            {renderPasswordDlg()}
            {renderChargeAlert()}
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal:horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>
    );
}
export default MyInfo;